/** @jsx jsx */
import React, { useState } from "react";
import { css, jsx } from "@emotion/core";
import { RecorderButton } from "components/atoms/Button";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { grayScale } from "components/styles";
import BodyText from "components/atoms/BodyText";
import useToastNotification from "hooks/useToastNotification";
import useBarcodeRecorder from "./hooks";
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
	formRecorder: css({
		textAlign: "center"
	}),
	dateForm: css({
		width: "312px",
		margin: "auto",
		justifyContent: `${isIpad ? 'center' : ''}`
	}),
	formContainer: css({
		marginTop: "16px",
		borderRadius: "3px",
	}),
	imageButton: css({
		width: "100%",
		textAlign: "center",
		height: "80px"
	})
};

const timeCss = css`
	align-items: baseline;
	justify-content: center;
	margin: auto;
	width: ${isIpad ? 'auto' : '350px'};
	color: red;
	line-height: ${isIpad ? '80px' : '100px'};
	span:first-of-type {
		font-size: ${isIpad ? '64px' : '100px'};
		color: ${grayScale.gray100};
		font-weight: bold;
	}
	span:last-of-type {
		font-size: 32px;
		color: ${grayScale.gray100};
	}
`;

const btnContainer = css`
	display: ${isIpad ? 'block' : 'flex'};
	text-align: center !important;
	flex-wrap: wrap;
	width: ${isIpad ? '100%' : '700px'};
	justify-content: center;
	margin: 30px auto 0 auto;
	height: auto;
	button {
		border-radius: 3px;
		border: 0;
		height: 120px;
		font-size: 24px;
		height: 120px;
		margin-bottom: 20px;
		margin-left: ${isIpad ? '0' : '30px'};
	}
	button:hover {
		opacity: 0.9;
	}
`;

const BarcodeRecorder: React.FC<{
	dataTimes: any;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
	fetchHistoryData: any;
}> = ({ dataTimes, setIsLoading, fetchHistoryData }) => {
	const { errorNotification } = useToastNotification();
	const [openModal, setOpenModal] = useState(false);

	const {
		handleSubmitBarcode,
		formik,
		formikConfirm,
		isConfirm,
		staffName,
		lastStampType,
		handleRecorder,
		stampType,
		setInputBarcodeId,
		serverDateTime,
		newUiRemote,
		handleSubmit
	} = useBarcodeRecorder(setOpenModal, setIsLoading, fetchHistoryData);

	return (
		<React.Fragment>
			<div css={styles.formContainer}>
				{
					!dataTimes.currentDay && 
					(
						<div 
							style={{
								fontSize: isIpad ? '30px' : '80px',
								textAlign: "center",
								marginBottom: "70px"
							}}
						>
							サーバ時間取得中・・・
						</div>
					)
				}

				<FlexBox customStyle={styles.dateForm}>
					<BodyText size="lg" color={grayScale.gray100}>
						{dataTimes.currentDay}
					</BodyText>
				</FlexBox>
				<FlexBox customStyle={timeCss}>
					<BodyText>{dataTimes.timeNow}</BodyText>
					<BodyText>{dataTimes.second}</BodyText>
				</FlexBox>

				{/* {!isConfirm && (
          <FlexBox customStyle={inputForm}>
            <FlexBoxItem basis="270px">
              <TextForm
                name="inputBarcodeId"
                label=""
                value={formik.values.inputBarcodeId}
                onChange={formik.handleChange}
                placeHolder="IDを入力してください"
              />
            </FlexBoxItem>
            <PrimaryButton
              text="IDを入力"
              onClick={() => handleSubmit()}
              minWidth="160px"
              customStyle={css({ fontWeight: "bold" })}
            />
          </FlexBox>
        )} */}

				{
					isConfirm && (
						<div style={{ width: "100%", textAlign: "center" }}>
							<BodyText color={grayScale.gray100} size={`${isIpad}` ? "md" : "xl"} bold={true}>
								{staffName}
								{(lastStampType === -1 || lastStampType === 3) && "さん、出勤打刻を押してください。"}
								{(lastStampType === 0 || lastStampType === 2) && "さん、退勤打刻または休憩開始を押してください。"}
								{lastStampType === 1 && "さん、休憩終了を押してください。"}
							</BodyText>
						</div>
					)
				}

				{/* <FlexBoxItem basis="48%">
					<PrimaryButton
						text="出社"
						onClick={() => {}}
						fullwidth={true}
						customStyle={css({
							backgroundColor: customButtonColor.green,
							"&:hover,&:focus": css({
								backgroundColor: customButtonColor.green,
							}),
						})}
					/>
      	</FlexBoxItem> */}

				{
					isConfirm && (
						<React.Fragment>
							<FlexBox customStyle={btnContainer}>
								{
									(lastStampType === -1 || lastStampType === 3) && !newUiRemote && (
										<FlexBoxItem basis="48%">
											<RecorderButton
												text="出勤"
												onClick={() => handleRecorder(0)}
												icon="checkInOffice"
												background="#007BC3"
											/>
										</FlexBoxItem>
									)
								}
								{
									(lastStampType === -1 || lastStampType === 3) && newUiRemote && (
										<React.Fragment>
											<FlexBoxItem basis="48%">
												<RecorderButton
													text="オフィス出勤"
													onClick={() => handleRecorder(0)}
													icon="checkInOffice"
													background="#007BC3"
												/>
											</FlexBoxItem>
											<FlexBoxItem basis="48%">
												<RecorderButton
													text="テレワーク出勤"
													onClick={() => handleRecorder(0, undefined, undefined, true)}
													icon="checkInRemote"
													background="#F8BF2D"
												/>
											</FlexBoxItem>
										</React.Fragment>
									)
								}
								{
									(lastStampType === 0 || lastStampType === 2) && (
										<FlexBoxItem basis="48%">
											<RecorderButton 
												text="退勤" 
												onClick={() => handleRecorder(3)} 
												icon="checkOut" 
												background="#666666" 
											/>
										</FlexBoxItem>
									)
								}
								{
									(lastStampType === 0 || lastStampType === 2) && (
										<FlexBoxItem basis="48%">
											<RecorderButton
												text="休憩開始"
												onClick={() => handleRecorder(1)}
												icon="breakStart"
												background="#00B172"
											/>
										</FlexBoxItem>
									)
								}
								{
									lastStampType === 1 && (
										<FlexBoxItem basis="48%">
											<RecorderButton
												text="休憩終了"
												onClick={() => handleRecorder(2)}
												icon="breakEnd"
												background="#8B2E9C"
											/>
										</FlexBoxItem>
									)
								}
							</FlexBox>
						</React.Fragment>
					)
				}
			</div>

			{/* <Modal
        open={openModal}
        closeHandler={() => setOpenModal(false)}
        title="打刻完了"
        submitText="閉じる"
        closeText=""
        onSubmit={() => formikConfirm.submitForm()}
        note="以下の内容で打刻しました"
      >
        <table css={tableModal}>
          <tbody>
          <tr>
            <th>氏名</th>
            <td>{formikConfirm.values.staffName}</td>
          </tr>
          <tr>
            <th>日付</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "YYYY年MM月DD日 (ddd)"
              )}
            </td>
          </tr>
          <tr>
            <th>時間</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "HH:mm:ss"
              )}
            </td>
          </tr>
          <tr>
            <th>打刻</th>
            <td>
              {stampType === 0 && <React.Fragment>出勤</React.Fragment>}
              {stampType === 1 && <React.Fragment>休憩開始</React.Fragment>}
              {stampType === 2 && <React.Fragment>休憩終了</React.Fragment>}
              {stampType === 3 && <React.Fragment>退勤</React.Fragment>}
            </td>
          </tr>
          </tbody>
        </table>
      </Modal> */}
			
		</React.Fragment>
	);
};

export default BarcodeRecorder;
